export default {
    formContainer: {
        marginTop: 18,
    },

    documentTypeContainer: {
        width: '100%'
    },

    bankContainer: {
        width: '100%'
    },

    documentNumber: {
        marginLeft: 10,
        width: "calc(100% - 10px)"
    },

    "@media all and (max-width: 600px)": {
        documentNumber: {
            margin: '25px 0 0 0',
            width: "100%"
        },
    }
}
